import { HttpInterceptorFn } from '@angular/common/http';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    setHeaders: {
      'Rabobank-Flow-ID': 'Test',
      'Rabobank-CRM-Source-System-Id': 'Test'
    }
  })
  return next(modifiedReq);
};
